import React from "react";
import { Bar, XAxis, YAxis, BarChart, LabelList } from "recharts";
import { valueConverter } from '../../util-functions/util-funtions'

let arr = []

const calculateValue = (value) => {
  if (value.data) {
    arr = [{ name: value.data[1]?.name, value: value.data[1]?.value, growth: valueConverter(value.data[1]?.value)+' | '+value.data[1]?.growth+"%", fill: '#0353a4' },
    { name: value.data[0]?.name, value: value.data[0]?.value, growth: valueConverter(value.data[0]?.value)+' | '+value.data[0]?.growth+"%", fill: '#fca311' }]
  }
}

function VerticalChart(props) {
  calculateValue(props)
  return (
    <>

      <BarChart
        width={250}
        height={150}
        data={arr}
        layout="vertical"
      >
        {/* <CartesianGrid opacity={0.5} vertical={false}/> */}
        <XAxis type="number" hide style={{ fontSize: '12px' }} />
        <YAxis dataKey="name" style={{ fontSize: '12px' }} type="category" tickLine={false} />
        {/* <Tooltip/> */}
        <Bar
          dataKey="value"
          fill={arr.fill}
          barSize={25}
        >
          <LabelList dataKey="growth" position="top" fontSize={12} fill={'black'}/>
        </Bar>
      </BarChart>
    </>
  );
}

export default VerticalChart;
